import React, { useState } from 'react';
import { NavLink } from "react-router-dom";
import '../css/NavBar.css';


const NavBar = () => {
  const [menuExpandido, setMenuExpandido] = useState(false);

  const toggleMenu = () => {
    setMenuExpandido(!menuExpandido);
  };

  return (
    <div className={`navbar ${menuExpandido ? 'expandido' : ''}`}>
      <div className="botao-toggle" onClick={toggleMenu}>
        ☰
      </div>
      {menuExpandido && (
        <div className="links">

          <ul>     <NavLink to="/dashboard">Principal</NavLink></ul>
          <ul>     <NavLink to="/dashboard/toolsconvenioweb">Toolsconvenioweb</NavLink></ul>
          <ul>     <NavLink to="/dashboard/ToolsGestorMob">ToolsGestorMob</NavLink></ul>
          <ul>     <NavLink to="/dashboard/all">Todos os recursos</NavLink></ul>
          <ul>     <NavLink to="/dashboard/API">API</NavLink></ul>
          <ul>     <NavLink to="/dashboard/PainelPix">PIX</NavLink></ul>
          <ul>     <NavLink to="/dashboard/PainelIFOOD">IFOOD</NavLink></ul>
          <ul>     <NavLink to="/dashboard/ConsultaDinamica">Consulta Dinâmica</NavLink></ul>
        </div>

      )}
    </div>

  );
};


export default NavBar;
